module.exports = "./img/41a116f75fdc6ede16a6e2e1a9154948.png";